import React from "react";
import Template from "./template";
import ErrorPage from "../../../components/shared/ErrorPage";
import { IsEmpty } from "../../../util/commonFunctions";

// sponsored by will add after some 16 iteration
const iteration = 12;

function VideoListingComponent({
  listing = [],
  sponsoredByData = {},
  totalResults = 0,
  isLoading = false
}) {
  let isHavingSponsored = false;
  let isSponsoredDone = false;
  let sponsoredAfter = 0;

  return Array.isArray(listing) && !IsEmpty(listing)
    ? listing.map((value, index) => {
        isHavingSponsored = false;
        if (!isSponsoredDone && totalResults <= iteration) {
          isHavingSponsored = true;
          sponsoredAfter = totalResults;
          isSponsoredDone = isHavingSponsored;
        } else if (!isSponsoredDone) {
          isHavingSponsored = true;
          sponsoredAfter = value.length;
          isSponsoredDone = isHavingSponsored;
        }
        return (
          <Template
            listing={value}
            key={"contentResults-" + index}
            isHavingSponsored={isHavingSponsored}
            sponsoredAfter={sponsoredAfter}
            sponsoredBy={sponsoredByData}
          />
        );
      })
    : isLoading && (
        <div className="col-12">
          <ErrorPage
            imageUrl="/assets/svg/tier-empty-state.svg"
            errorPageHeading="No content found"
            errorPageDescription="You have not followed anything yet.  Looking for something in particular? Try"
            paraUrl="/search"
            paraUrlText="starting a search"
            class="tier"
          />
        </div>
      );
}

export { VideoListingComponent };
